import React, { Dispatch, SetStateAction } from 'react';
import { TagsInput } from "react-tag-input-component";

import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { expressions } from '../../../../libraries/regular.expressions.library';
import { legendInvalid, legendValid, legendValidInvalidRestart } from '../../../../tools/legend.data.entry.tool';
import { evaluateLegendValidRequiredIcon } from '../../../../scripts/validate.legend.script';

import AppLegend from '../../../../components/element/Legend';

export interface AppInventoryFormGeneralProps {
  inventory: string,
  action: string,
  display: string,
  other: boolean,
  name: {value: string, valid: boolean},
  tags: {value: string[], valid: boolean},
  setName: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setTags: Dispatch<SetStateAction<{value: string[], valid: boolean}>>
};

const AppInventoryFormGeneral: React.FunctionComponent<AppInventoryFormGeneralProps> = ({inventory, action, display, other, name, tags, setName, setTags}) => {
  const {lang} = StateLanguage()

  const handleChangeName = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    setName({...name, value: event.target.value})
  }

  const validateName = () => {
    evaluateLegendValidRequiredIcon(expressions.name, name, setName, 'input-name', 'legend-name-valid', 'legend-name-required')
    evaluateLegendValidRequiredIcon(expressions.name, name, setName, 'input-name-other', 'legend-name-other-valid', 'legend-name-other-required')
  }

  const handleChangeTags = (items: string[]) => {
    setTags({...tags, value: items})
  }

  const validateTagKeyUp = (event: React.KeyboardEvent <HTMLFormElement | HTMLInputElement>) => {
    if (expressions && expressions.tag.test(event.currentTarget.value)) {
      if (!tags.value.includes(event.currentTarget.value)) {
        setTags({...tags, valid: true})
        legendValid('legend-tags-valid')
        legendValid('legend-tags-exists')
        legendValid('legend-tags-other-valid')
        legendValid('legend-tags-other-exists')
      } else {
        setTags({...tags, valid: false})
        legendInvalid('legend-tags-exists')
        legendInvalid('legend-tags-other-exists')
      }
    } else {
      setTags({...tags, valid: false})
      legendInvalid('legend-tags-valid')
      legendInvalid('legend-tags-other-valid')
    }
  }

  const validateTagBlur = (event: React.FocusEvent <HTMLFormElement | HTMLInputElement>) => {
    /* if (expressions && event.currentTarget.value.length > 0 && expressions.tag.test(event.currentTarget.value) && !tags.value.includes(event.currentTarget.value)) {
      setTags({...tags, value: [...tags.value, event.currentTarget.value], valid: true})
      legendValid('legend-tags-required')
      legendValid('legend-tags-other-required')
    } else if (tags.value.length === 0) {
      setTags({...tags, valid: false})
      legendInvalid('legend-tags-required')
      legendInvalid('legend-tags-other-required')
    } */

    if (tags.value.includes(event.currentTarget.value)) {
      setTags({...tags, valid: true})
      legendValidInvalidRestart('legend-tags-exists')
      legendValidInvalidRestart('legend-tags-other-exists')
    }

    event.currentTarget.value = ''
    legendValidInvalidRestart('legend-tags-valid')
    legendValidInvalidRestart('legend-tags-other-valid')
  }

  const validateTagAdd = (item: string, items: string[]) => {
    if (expressions && items) {
      if (expressions.tag.test(item)) {
        setTags({...tags, valid: true})
        legendValid('legend-tags-valid')
        //legendValid('legend-tags-required')
        legendValid('legend-tags-other-valid')
        //legendValid('legend-tags-other-required')
        return true;
      } else {
        setTags({...tags, valid: false})
        legendInvalid('legend-tags-valid')
        legendInvalid('legend-tags-other-valid')
        return false;
      }
    } else {
      setTags({...tags, valid: false})
      legendValidInvalidRestart('legend-tags-valid')
      //legendValidInvalidRestart('legend-tags-required')
      legendValidInvalidRestart('legend-tags-other-valid')
      //legendValidInvalidRestart('legend-tags-other-required')
      return false;
    }
  }

  const validateTagExisting = (item: string) => {
    if (item.length > 0) {
      setTags({...tags, valid: false})
      legendInvalid('legend-tags-exists')
      legendInvalid('legend-tags-other-exists')
    } else {
      setTags({...tags, valid: true})
      legendValid('legend-tags-exists')
      legendValid('legend-tags-other-exists')
    }
  }

  const validateTagRemoved = (item: string) => {
    /* if (item.length > 0 && tags.value.length === 1) {
      setTags({...tags, valid: false})
      legendInvalid('legend-tags-required')
      legendInvalid('legend-tags-other-required')
    } else {
      setTags({...tags, valid: true})
      legendValid('legend-tags-required')
      legendValid('legend-tags-other-required')
    } */

    setTags({...tags, valid: true})
  }

  return (
    <div className={`card card-flush ${display}`}>
      <div className="card-header">
        <div className="card-title">
          <h3>{lang.labels.general}</h3>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="mb-3">
          <label className="form-label required">{lang.labels[`${inventory}Name` as keyof typeof lang.labels]}</label>
          <input id={other ? "input-name-other" : "input-name"} className="form-control form-control-solid" type="text" autoComplete="off" name="name" value={name.value} onChange={handleChangeName} onKeyUp={validateName} onBlur={validateName} />
          <div className={`form-text text-justify ${action === "update" && "d-none"}`}>{lang.labels[`${inventory}NameRequiredAndRecommendedUnique` as keyof typeof lang.labels]}</div>
          <AppLegend attribute={{check: name.valid, name: other ? "name-other" : "name", index: null, sub_index: null}} container={{valid: true, required: true, identical: false, exists: false}}></AppLegend>
        </div>
        <div className="mb-0">
          <label className="form-label">{lang.labels.tags}</label>
          <TagsInput classNames={{tag: "tag-cls bg-dark bg-opacity-10 fs-7", input: "input-cls form-control form-control-solid w-100"}} name="tags" value={tags.value} onChange={handleChangeTags} onKeyUp={validateTagKeyUp} onBlur={validateTagBlur} beforeAddValidate={validateTagAdd} onExisting={validateTagExisting} onRemoved={validateTagRemoved} />
          <div className={`form-text text-justify ${action === "update" && "d-none"}`}>{lang.labels[`addTagsTo${inventory.charAt(0).toUpperCase()}${inventory.slice(1)}` as keyof typeof lang.labels]}</div>
          <AppLegend attribute={{check: tags.valid, name: other ? "tags-other" : "tags", index: null, sub_index: null}} container={{valid: true, required: false, identical: false, exists: true}}></AppLegend>
        </div>
      </div>
    </div>
  )
};

export default AppInventoryFormGeneral;
